import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactUsSection from './components/ContactUsSection';
import JsonLd from '@/components/base/JsonLd';
import { useSectionView } from '@/components/feature/SectionViewProvider';
import HelpCenterPage from '@/pages/help-center/page';
import PrivacyPolicyPage from '@/pages/privacy-policy/page';
import TermsOfServicePage from '@/pages/terms-of-service/page';

export default function HomePage() {
  const { activeDoc } = useSectionView();
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://settlespace.in';

  // Dynamic state views (help / privacy / terms) render in the middle area on
  // first load based on the ?section= query parameter — no separate sub-routes.
  if (activeDoc === 'help') return <HelpCenterPage />;
  if (activeDoc === 'privacy') return <PrivacyPolicyPage />;
  if (activeDoc === 'terms') return <TermsOfServicePage />;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${siteUrl}/#business`,
    name: 'SettleSpace',
    url: siteUrl,
    logo: `${siteUrl}/assets/logo.png`,
    image: `${siteUrl}/assets/hero.jpg`,
    description: 'SettleSpace simplifies the rental process for both tenants and owners in Kharghar, Navi Mumbai. We handpick quality rental properties and provide trusted support every step of the way.',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Kharghar',
      addressRegion: 'Maharashtra',
      addressCountry: 'IN',
    },
    areaServed: {
      '@type': 'City',
      name: 'Navi Mumbai',
    },
    telephone: '+91-85910-19785',
    email: 'hitesh@settlespace.in',
    sameAs: [
      'https://www.instagram.com/settlespacein/',
      'https://www.facebook.com/profile.php?id=61591673264062',
      'https://www.linkedin.com/company/settlespace/',
      'https://www.youtube.com/@settlespacein',
      'https://x.com/settlespacein',
    ],
    priceRange: 'INR',
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        opens: '09:00',
        closes: '18:00',
      },
    ],
  };

  return (
    <>
      <JsonLd data={jsonLd} />
      <HeroSection />
      <FeaturesSection />
      <div id="services" className="scroll-mt-20 md:scroll-mt-24"><ServicesSection /></div>
      <div id="testimonials" className="scroll-mt-20 md:scroll-mt-24"><TestimonialsSection /></div>
      <div id="contact" className="scroll-mt-20 md:scroll-mt-24"><ContactUsSection /></div>
    </>
  );
}